import {Component} from '@angular/core';
import {AlertController, NavController, NavParams} from 'ionic-angular';
import {OrderService} from "../../services/OrderService";
import {OrderViewPage} from "../order-view/order-view";
import {OrderInfo} from "../nav/OrderInfo";
import {ActivityDate, DateService} from "../../services/DateService";
import {DailyPlanningMissionOrderPlanningReport, Order} from "../../model/Order";
import {PhotoService} from "../../services/PhotoService";
import {MissionReportPhoto} from "../../model/MissionReportPhoto";
import {PcheckService} from "../../services/PcheckService";
import {apiconfig} from "../../app/api.config";
import {OperationService} from "../../services/OperationService";
import {AuthService} from "../../services/AuthService";
import {OrderEditPage} from "../order-edit/order-edit";
import {LocupaUtilsServiceProvider} from "../../providers/locupa-utils-service/locupa-utils-service";
import {OperationCustomerPlanningSetting} from "../../model/Operation";
import {StartOrderPage} from "../start-order/start-order";
import {StoreService} from "../../services/StoreService";
import {MonthlyCalenderPreviewReport, StoreActivityDay} from "../../model/Store";
import {TourPlanningDuplicateResponse} from "../../model/OrderRequest";
import {ActionDone} from "../../model/LogaProxy";

/**
 * Generated class for the OrderListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


export class MyDatePickerFilter {
  year: number;
  month: number;
  dateLabel: Date;

  nextMonth() {
    if (this.month >= 11) {
      this.month = 0;
      this.year++;
    } else {
      this.month++;
    }
  }

  previousMonth() {
    if (this.month <= 0) {
      this.month = 11;
      this.year--;
    } else {
      this.month--;
    }
  }

}


export class MissionPhotoCounter {
  public orderId: number;
  public counter: number;
  public operationId: number;
}


@Component({
  selector: 'daily-view',
  templateUrl: 'daily-view.html',
})
export class DailyViewPage {

  /**
   * flag to tell the UI it's currently loading
   */
  public uiLoadingComplete: boolean = false;

  protected planningReport: DailyPlanningMissionOrderPlanningReport;


  public photoCounters: any;
  private currentDay: ActivityDate;

  public ordersPerOperationKeys: string[] = [];

  public iconsURL: string = apiconfig.LOGA_ICONS;

  // Array qui donne l'infor pour une operation d'afficher ou non les informations de présence
  public showPresenceCheckInfosPerOp: any;
  public showPresenceCheckPhotos: any;
  public showCraPhotos: any;

  protected uiNumberOfVisibleOrders: number;

  //id of the daily tour planning
  protected tourPlanningIdentifier: number;

  protected uiShowDatePicker: boolean;
  protected uiMyDatePickerFilter: MyDatePickerFilter;

  protected monthlyCalandarPreviewReport: MonthlyCalenderPreviewReport;
  protected uiDuplicateReport: TourPlanningDuplicateResponse;
  protected uiDuplicateDatePickerLoading: boolean;

  private uiActionDoneReport: ActionDone;


  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public orderService: OrderService,
              public dateService: DateService,
              public photoService: PhotoService,
              public pcheckService: PcheckService,
              public operationService: OperationService,
              public  authService: AuthService,
              public locupaUtilsServiceProvider: LocupaUtilsServiceProvider,
              public storeService: StoreService,
              public alertCtrl: AlertController) {

  }

  ionViewWillEnter() {
    // hopeful we will get a day from the navigation
    let dayToDisplay = this.navParams.data['day'];
    if (dayToDisplay != null) {
      this.currentDay = new ActivityDate().withTimeStamp(dayToDisplay);
    }

    // fallback scenario, we need one day to show, let's get today
    if (!this.currentDay)
      this.currentDay = this.dateService.getToday();

    this.uiActionDoneReport = null;

    this.uiMyDatePickerFilter = new MyDatePickerFilter();
    this.uiMyDatePickerFilter.month = this.currentDay.asDate().getMonth();
    this.uiMyDatePickerFilter.year = this.currentDay.asDate().getFullYear();

    this.tourPlanningIdentifier = this.navParams.data['tourPlanningIdentifier'];

    this.searchOrders();
  }


  displayMonthlyDatePicker(): Promise<any> {
    return this.storeService.loadMonthlyCalenderPreviewReport(this.uiMyDatePickerFilter.year, this.uiMyDatePickerFilter.month + 1).then((rr: MonthlyCalenderPreviewReport) => {
      this.monthlyCalandarPreviewReport = rr;
      this.uiMyDatePickerFilter.dateLabel = new Date();
      this.uiMyDatePickerFilter.dateLabel.setFullYear(rr.year);
      this.uiMyDatePickerFilter.dateLabel.setMonth(rr.month, 1);
      this.uiDuplicateDatePickerLoading = false;
    });
  }


  onLoadOrder(p_orderId: number, index: number) {

    let orderInfo: OrderInfo;

    orderInfo = new OrderInfo();
    console.log("looking for order with id: " + p_orderId);

    let selectOrder: Order = this.planningReport.findOrderById(p_orderId);
    if (selectOrder != undefined) {
      orderInfo.order = selectOrder.id;

      // operation info
      orderInfo.operation.id = selectOrder.operation.id;
      orderInfo.operation.name = selectOrder.operation.name;

      // store info
      orderInfo.store.id = selectOrder.location.id;
      orderInfo.store.name = selectOrder.location.name;

      // load pcheck for this day before opening the details of the order
      this.pcheckService.findPcheck(selectOrder.id)
        .then((pchecks) => {
          if (selectOrder.customerEditPermissionAllowed)
            this.navCtrl.push(OrderEditPage, {orderInfo, pchecks});
          else
            this.navCtrl.push(OrderViewPage, {orderInfo, pchecks});
        });

    } else {

      let alert = this.alertCtrl.create({
        title: 'Intervention',
        subTitle: "Impossible de retrouver les informations de cette intervention. (id= " + p_orderId + ")" +
          "Merci ré-essayer ultérieurement ou de contacter votre responsable de dossier.",
        buttons: ['Fermer'],
      });
      alert.present();

    }

  }

  /**
   *
   * @param durationInMinutes
   */
  toFormatMissionDuration(durationInMinutes: number): string {
    let nbHours = Math.floor(durationInMinutes / 60);
    let nbMinutes = Math.floor(durationInMinutes % 60);

    if (nbMinutes && nbMinutes > 0) {
      return nbHours + "h" + nbMinutes;
    }

    return nbHours + "h";
  }

  newOrder(fromOrder: Order) {
    if (fromOrder == null)
      return this.navCtrl.push(StartOrderPage, {
        operationId: null,
        defaultDate: this.currentDay.dateStamp,
        tourIdentifier: this.tourPlanningIdentifier,
        tourDay: this.currentDay.dateStamp,
        previousOrderInTour: null
      });
    else {
      return this.navCtrl.push(StartOrderPage, {
        operationId: fromOrder == null ? null : fromOrder.operation.id,
        defaultDate: this.currentDay.dateStamp,
        tourIdentifier: this.tourPlanningIdentifier,
        tourDay: this.currentDay.dateStamp,
        previousOrderInTour: fromOrder
      });
    }
  }

  nextDay() {
    this.currentDay.addDay();
    this.planningReport = null;
    this.searchOrders();
  }

  previousDay() {
    this.currentDay.removeDay();
    this.planningReport = null;
    this.searchOrders();
  }


  searchOrders() {

    this.uiLoadingComplete = false;

    this.photoCounters = new Map();
    this.showPresenceCheckInfosPerOp = new Map();
    this.showPresenceCheckPhotos = new Map();
    this.showCraPhotos = new Map();

    this.orderService.loadDailyTourPlanningReport(this.tourPlanningIdentifier)
      .then((report) => {

        this.planningReport = report;

        // -- we want to store in cache the operation settings
        let operationSettingsCache = [];
        let allP = [];
        let allOperationIds: number[] = [];

        if (report.days != null)
          report.days.forEach(day => {
            if (day.operationReports != null)
              day.operationReports.forEach(opRep => {
                if (allOperationIds.indexOf(opRep.operationId) < 0)
                  allOperationIds.push(opRep.operationId);
              });
          })


        for (let id of allOperationIds) {
          allP.push(this.operationService.loadOperationCustomerPlanningSettings(id).then(planificationSettings => {
            operationSettingsCache[id] = planificationSettings;
            this.showPresenceCheckInfosPerOp.set(id, planificationSettings.showPresenceCheckInfos)

            this.showPresenceCheckInfosPerOp.set(id, planificationSettings.showPresenceCheckInfos);
            // doit on voir l'information "nb photos" ?
            this.showPresenceCheckPhotos.set(id, planificationSettings.showCheckInQuestionnaire !== 'NO');
            this.showCraPhotos.set(id, planificationSettings.showCra !== 'NO');
          }));
        }


        Promise.all(allP).then(() => {
          // operation settings is now loaded we can process with content loading / rendering
          for (let order of report.getAllOrders()) {

            order.uiPresenceCheckString = this.processAlertOnPcheckString(order.pcheckAlerts);

            if (!this.ordersPerOperationKeys.find(opName => opName === order.operation.name))
              this.ordersPerOperationKeys.push(order.operation.name);
          }
        }).then(() => {

          let ordersPerOperationId: Map<number, Order[]> = this.locupaUtilsServiceProvider.groupBy(report.getAllOrders(), function (a: Order) {
            return a.operation.id;
          });

          ordersPerOperationId.forEach((value: Order[], key: number) => {

            let i, j, chunk = 200;
            for (i = 0, j = value.length; i < j; i += chunk) {
              let bucket = value.slice(i, i + chunk);

              let missionIds = [];
              bucket.forEach(m => missionIds.push(m.id));

              this.photoService.searchPhoto(null, null, key, null, missionIds)
                .then(
                  (missionsPhotoReport: MissionReportPhoto[]) => {
                    if (missionsPhotoReport != null)
                      missionsPhotoReport.forEach((ph) => {
                        this.appendPhotoToLocalCounter(ph, operationSettingsCache[ph.operationId], ph.operationId);
                      });
                  });
            }
          });
        });


        this.uiLoadingComplete = true;
      });
  }

  /**
   * will check the current operation setting configuration, and increment counter according to photo type
   * @param ph
   * @param opSetting
   * @param cnt
   */
  private appendPhotoToLocalCounter(ph: MissionReportPhoto, opSetting: OperationCustomerPlanningSetting, operationId: number) {

    if (this.photoCounters.get(ph.missionId) === undefined) {
      let counterTab: MissionPhotoCounter[] = [];
      this.photoCounters.set(ph.missionId, counterTab);
    }

    // get array
    let counterTab: MissionPhotoCounter[] = this.photoCounters.get(ph.missionId);

    // find element from array
    let cnt: MissionPhotoCounter = counterTab.find(o => (o.orderId === ph.missionId));

    // change element or add new one
    if (cnt == null) {
      cnt = new MissionPhotoCounter();
      cnt.orderId = ph.missionId;
      cnt.counter = 0;
      cnt.operationId = operationId;
      counterTab.push(cnt)
    }

    cnt.counter = cnt.counter + 1;
  }

  private processAlertOnPcheckString(pcheckAlerts: any[]): string {
    let alert: string = '';
    if (pcheckAlerts != null) {
      pcheckAlerts.forEach(a => {
        alert = alert.concat(a);
      });
    }
    return alert;
  }

  public showPresenceCheckInfos(p_operation: number): boolean {
    if (this.showPresenceCheckInfosPerOp !== undefined)
      return this.showPresenceCheckInfosPerOp.get(p_operation);
    return false;
  }

  public showNbPictures(p_operationId: number): boolean {
    if (this.showPresenceCheckPhotos !== undefined && this.showCraPhotos !== undefined) {
      return this.showPresenceCheckPhotos.get(p_operationId) || this.showCraPhotos.get(p_operationId);
    }
    return false;
  }


  /**
   * will try to delete the mission
   * @param id
   */
  requestMissionDelete(id: number) {

    let alert = this.alertCtrl.create({
      title: 'Suppression de Mission',
      message: 'Êtes-vous sûr de vouloir supprimer cette commande ?',
      buttons: [
        {text: 'Annuler', role: 'cancel'},
        {
          text: 'Valider',
          handler: () => {
            this.orderService.deleteOrder(id).then(success => {
              this.searchOrders()
            })
          }
        }
      ]
    });
    return alert.present();
  }

  showDuplicateDatePicker() {
    this.uiDuplicateDatePickerLoading = false;
    this.displayMonthlyDatePicker().then(any => {
      console.log(this.monthlyCalandarPreviewReport);
      this.uiShowDatePicker = true;
    })
  }

  adActiveClass(ad: StoreActivityDay) {
    if (this.currentDay == null)
      return "inactive";
    else return ad.logaDay == this.currentDay.dateStamp ? "active" : "inactive";
  }

  proceedToDuplicate(ad: StoreActivityDay) {
    this.uiDuplicateDatePickerLoading = true;
    return this.orderService.duplicateTour(this.tourPlanningIdentifier, ad.logaDay).then(duplicateReport => {
      console.log(duplicateReport);
      this.uiDuplicateReport = duplicateReport;
      return duplicateReport;
    }).then(any => {
      return this.displayMonthlyDatePicker();
    });
  }

  /**
   *
   */
  pickerPreviousMonth() {
    this.uiDuplicateDatePickerLoading = true;
    this.uiMyDatePickerFilter.previousMonth();
    this.displayMonthlyDatePicker();
  }

  /**
   *
   */
  pickerNextMonth() {
    this.uiDuplicateDatePickerLoading = true;
    this.uiMyDatePickerFilter.nextMonth();
    this.displayMonthlyDatePicker();
  }

  displayDuplicateOk(uiDuplicateReport: TourPlanningDuplicateResponse) {
    this.currentDay = null;

    this.currentDay = new ActivityDate().withTimeStamp(uiDuplicateReport.dailyTourPlanning.referenceDate);
    this.tourPlanningIdentifier = uiDuplicateReport.dailyTourPlanning.id;

    this.uiShowDatePicker = false;
    this.planningReport = null;

    this.searchOrders();
  }


  deleteAllTour() {
    let alert = this.alertCtrl.create({
      title: 'Suppression Planification',
      subTitle: "Souhaitez-vous réellement supprimer le plan de tournée ?",
      buttons: [{
        text: "Supprimer",
        handler: data => {
          this.deleteCurrentDailyTourPlanning();

        }
      }],
    });
    alert.present();
  }

  /**
   *
   */
  private deleteCurrentDailyTourPlanning() {

    let allP = [];
    this.uiLoadingComplete = false;
    this.uiActionDoneReport = null;

    this.orderService.deleteDailyTourPlanning(this.tourPlanningIdentifier).then(r => {
      this.planningReport = null;
      this.uiActionDoneReport = r;
      this.uiLoadingComplete = true;
    });

  }

  /**
   * call back when action is complete and the current page is not relevant anymore
   */
  backToPreviousPlanningPage() {
    return this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/order-list/daily-view.ts